<div
  class="scope-row-content flex items-center"
  [class.trading-in-progress]="isTradingInProgress"
  (click)="fetchDeliverable($event)">
  <div
    class="column level-{{ level }}"
    [ngClass]="config?.mainColumnClass">
    <div class="flex items-center">
      <mat-icon
        [class.trade-confirmed]="isTraded"
        class="arrow orange material-symbols-rounded"
        [class.active]="scopeElementsService.deliverableStates.selected[deliverable.id]">
        expand_more
      </mat-icon>
      <i
        class="scope-row-icon material-symbols-rounded mr-1"
        [class.trade-confirmed]="isTraded">
        {{ deliverable.fixedPricing ? 'book' : 'description' }}
      </i>
      <div class="flex-col">
        <commentable
          [c-if]="
            config?.scopeVersion.hasPrivilegeValueRestrictionByScopeValue(Privilege.SCOPE_COMMENT__CREATE, currentUser)
          "
          [c-entity]="deliverable"
          c-type="deliverable"
          c-key="name"
          [class.trade-confirmed]="isTraded">
          {{ deliverable.name }}
          <small
            class="text"
            *ngIf="deliverable.tradedFrom">
            (Traded for {{ deliverable.tradedFrom.name }})
          </small>
        </commentable>
        <span
          *ngIf="deliverable.discipline?.name?.length"
          class="source-name">
          {{ deliverable.discipline.name }}
        </span>
      </div>
      <div
        *ngIf="!scopeApprovalFlowService.isStateDraft(config?.scopeVersion.status) && getCommentsCount() > 0"
        class="scope-comments-total-count-icon"
        title="Roll-up Comments Count">
        <div class="scope-comments-count">{{ getCommentsCount() }}</div>
      </div>
    </div>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.DELIVERY_STATUS?.isVisible()">
    <div
      *ngIf="deliveryStatus"
      class="text center scope-status">
      <span
        [class]="deliveryStatus.class"
        [matTooltip]="deliveryStatus.tooltip">
        {{ deliveryStatus.name }}
      </span>
    </div>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.CREATED_BY?.selected">
    <span [class.trade-confirmed]="isTraded">{{ deliverable.createdBy.getFullname() }}</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.OWNER?.selected">
    <span [class.trade-confirmed]="isTraded">{{ deliverable.owner.getFullname() }}</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.DATE_CREATED?.selected">
    <span [class.trade-confirmed]="isTraded">
      {{ deliverable.createdTs | dateFormat: 'shortDate' }}
    </span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.QUANTITY?.selected">
    <scope-ui-counter
      *ngIf="config?.isEditable"
      [initialValue]="deliverable.quantity"
      [min]="0"
      (onUpdateValue)="updateDeliverable({ quantity: $event })"></scope-ui-counter>
    <span
      *ngIf="!config?.isEditable"
      [class.trade-confirmed]="isTraded">
      {{ deliverable.quantity }}
    </span>
  </div>
  <div
    class="column one--column"
    [hidden]="!isPreferenceActive(config?.userColumns.START_DATE)">
    <span [class.trade-confirmed]="isTraded">{{ deliverable.startDate | dateFormat: 'shortDate' }}</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.LAST_EDITED?.selected">
    <span [class.trade-confirmed]="isTraded">{{ deliverable.updatedTs | dateFormat: 'shortDate' }}</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!isPreferenceActive(config?.userColumns.END_DATE)">
    <span [class.trade-confirmed]="isTraded">{{ deliverable.endDate | dateFormat: 'shortDate' }}</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.MARK_UP?.selected">
    <span [class.trade-confirmed]="isTraded">{{ deliverable.getMarkup() }}%</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.PROFIT?.selected">
    <span [class.trade-confirmed]="isTraded">
      {{ deliverable.getTotalProfit().amount | convertCurrency: config?.currency }}
    </span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.SCOPEMARK_HOURS?.selected">
    <commentable
      [c-if]="
        config?.scopeVersion.hasPrivilegeValueRestrictionByScopeValue(Privilege.SCOPE_COMMENT__CREATE, currentUser)
      "
      [c-entity]="deliverable"
      [c-key]="'scopeMarkTotalHours'"
      [c-type]="'deliverable'"
      [class.trade-confirmed]="isTraded">
      {{ deliverable.scopeMarkTotalHours | formatHours }}
    </commentable>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.SCOPEMARK_PRICE?.selected">
    <commentable
      [c-if]="
        config?.scopeVersion.hasPrivilegeValueRestrictionByScopeValue(Privilege.SCOPE_COMMENT__CREATE, currentUser)
      "
      [c-entity]="deliverable"
      [c-key]="'scopeMarkTotalSellingPrice'"
      [c-type]="'deliverable'"
      [class.trade-confirmed]="isTraded">
      {{
        deliverable.scopeMarkTotalSellingPrice
          ? (deliverable.scopeMarkTotalSellingPrice.amount | convertCurrency: config?.currency)
          : '--'
      }}
    </commentable>
  </div>
  <div
    class="column {{ config?.isTimeline ? 'three--columns' : 'one--column' }}"
    [hidden]="!config?.isTimeline && !config?.userColumns.AGENCY_HOURS?.selected">
    <commentable
      [c-if]="
        config?.scopeVersion.hasPrivilegeValueRestrictionByScopeValue(Privilege.SCOPE_COMMENT__CREATE, currentUser)
      "
      [c-entity]="deliverable"
      [c-key]="'rateCardTotalHours'"
      [c-type]="'deliverable'"
      [class.trade-confirmed]="isTraded">
      {{ deliverable.getTotalRateCardHours() | formatHours }}
    </commentable>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.BUDGET?.selected">
    <commentable
      [c-if]="
        config?.scopeVersion.hasPrivilegeValueRestrictionByScopeValue(Privilege.SCOPE_COMMENT__CREATE, currentUser)
      "
      [c-entity]="deliverable"
      [c-key]="'budget'"
      [c-type]="'deliverable'"
      [class.trade-confirmed]="isTraded">
      {{ deliverable.budget?.amount | convertCurrency: config?.currency }}
    </commentable>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.BALANCE?.selected">
    <commentable
      [c-if]="
        config?.scopeVersion.hasPrivilegeValueRestrictionByScopeValue(Privilege.SCOPE_COMMENT__CREATE, currentUser)
      "
      [c-entity]="deliverable"
      [c-key]="'budgetBalance'"
      [c-type]="'deliverable'"
      [class.trade-confirmed]="isTraded">
      <span
        [class.text-error-600]="deliverable.budget && deliverable?.budgetBalance?.amount < 0"
        matTooltip="Over {{ 'deliverable|l' | lang }} budget of {{
          deliverable.budget?.amount | convertCurrency: config?.currency
        }}"
        matTooltipPosition="above"
        [matTooltipDisabled]="!(deliverable.budget && deliverable?.budgetBalance?.amount < 0)">
        {{ deliverable.budgetBalance ? (deliverable.budgetBalance.amount | convertCurrency: config?.currency) : '--' }}
      </span>
    </commentable>
  </div>
  <div
    class="column {{ config?.isTimeline ? 'three--columns' : 'one--column' }}"
    [hidden]="!config?.isTimeline && !config?.userColumns.AGENCY_PRICE?.selected">
    <div
      class="flex flex-col items-center deliverable-agency-price"
      [has-privilege]="Privilege.SCOPE__VIEW_RATES">
      <span
        *ngIf="deliverable?.fixedPricing"
        class="fixed-price-label">
        fixed fee
      </span>

      <span
        *ngIf="deliverable.containsUnmappedScopeMarkRoles"
        class="inline-block"
        [class.trade-confirmed]="isTraded">
        --
      </span>

      <ng-template #agencyPrice>
        {{
          deliverable.getTotalSellingPrice().amount != null
            ? (deliverable.getTotalSellingPrice().amount | convertCurrency: config?.currency)
            : '--'
        }}
      </ng-template>

      <ng-container *ngIf="!deliverable.containsUnmappedScopeMarkRoles">
        <commentable
          *ngIf="!isAgencyPriceEditable"
          class="inline-block"
          [class.trade-confirmed]="isTraded"
          [c-entity]="deliverable"
          [c-key]="'agencyTotalPrice'"
          [c-type]="'deliverable'"
          [has-privilege]="Privilege.SCOPE__VIEW_RATES"
          [has-privilege-mask]="'--'"
          [c-if]="
            config?.scopeVersion.hasPrivilegeValueRestrictionByScopeValue(Privilege.SCOPE_COMMENT__CREATE, currentUser)
          ">
          <ng-container [ngTemplateOutlet]="agencyPrice"></ng-container>
        </commentable>

        <div
          *ngIf="isAgencyPriceEditable"
          class="flex items-center justify-center scope-editable-field">
          <ng-container *ngIf="!isEditAgencyPrice">
            <ng-container [ngTemplateOutlet]="agencyPrice"></ng-container>

            <mat-icon
              class="material-symbols-rounded fill orange text-sm"
              (click)="editAgencyPrice($event)">
              mode_edit
            </mat-icon>
          </ng-container>

          <scope-ui-input
            *ngIf="isEditAgencyPrice"
            type="text"
            [parseNumber]="true"
            [isCurrency]="true"
            [autofocus]="true"
            [noArrows]="true"
            [maximumLength]="17"
            [currency]="config?.currency"
            [initialValue]="deliverable.getUnitSellingPrice()?.amount"
            [control]="agencyPriceControl"
            (click)="preventDefault($event)"
            (onInputBlurChange)="updateAgencyPrice($event)" />
        </div>
      </ng-container>
    </div>

    <mat-icon
      *ngIf="
        config?.isTimeline &&
        !deliverable.containsUnmappedScopeMarkRoles &&
        deliverable.getTotalSellingPrice().amount == 0
      "
      class="scope-error-icon material-symbols-rounded"
      matTooltip="Empty deliverable. Edit to add components">
      error
    </mat-icon>
    <mat-icon
      *ngIf="config?.isTimeline && deliverable.containsUnmappedScopeMarkRoles"
      class="scope-error-icon material-symbols-rounded"
      matTooltip="This {{ 'deliverable|l' | lang }} has roles which do not exist in your ratecard">
      error
    </mat-icon>
  </div>

  <div
    class="column one--column"
    [hidden]="!config?.showActionsColumn">
    <button
      *ngIf="showToggleMenu()"
      mat-mini-fab
      class="toggle-button float-right ml-1"
      [ngClass]="config?.isTimeline ? 'mr-1' : 'mr-2'"
      [matMenuTriggerFor]="deliverableMenu"
      (click)="$event.stopPropagation()">
      <mat-icon class="material-symbols-rounded">more_horiz</mat-icon>
    </button>
    <mat-menu
      #deliverableMenu="matMenu"
      backdropClass="customize">
      <ng-container *ngFor="let option of deliverableMenuOptions">
        <button
          *ngIf="!(option.isHidden?.(deliverable) || option.isDetached?.(deliverable))"
          mat-menu-item
          (click)="option.callback(deliverable)">
          <mat-icon class="material-symbols-rounded orange">{{ option.icon() }}</mat-icon>
          <span class="library-option-name">{{ option.name() | langf }}</span>
        </button>
      </ng-container>
    </mat-menu>

    <ng-container *ngFor="let option of deliverableMenuOptions">
      <button
        *ngIf="!option.isHidden?.(deliverable) && option.isDetached?.(deliverable)"
        class="toggle-button float-right ml-1"
        mat-mini-fab
        (click)="option.callback(deliverable)">
        <mat-icon class="material-symbols-rounded fill">mode_edit</mat-icon>
      </button>
    </ng-container>
  </div>
</div>

<div
  *ngIf="!config?.isTimeline"
  class="flex flex-col w-full scope-description-container">
  <description-editor
    class="level-{{ level }} description-editor"
    [(visible)]="scopeElementsService.deliverableStates.description[deliverable.id]"
    [model]="deliverable"
    [editable]="isEditable"
    [extraDescription]="true"
    [(disableDragging)]="scopeElementsService.disableDragging"
    (onSaveDescription)="updateDeliverable({ description: $event })"
    (onSaveExtraDescription)="saveDeliverableExtraDescription($event)"
    (onSaveNote)="updateDeliverable({ internalNote: $event })">
  </description-editor>

  <!-- Accept/Reject Deliverables -->
  <ng-container *ngIf="scopeApprovalFlowService.stateChecks">
    <div
      class="deliverable-review-container"
      *ngIf="
        scopeApprovalFlowService.stateChecks.deliverableStatus.deliverablesInReview &&
        scopeApprovalFlowService.stateChecks.isCurrentVersion &&
        scopeApprovalFlowService.stateChecks.inReviewState.currentMember
      ">
      <div class="deliverable-review-collaborators">
        <div class="approval-collaborators-list flex flex-col gap-1">
          <div class="flex items-center gap-0.5">
            <mat-icon class="material-symbols-rounded">people</mat-icon>
            <h6 class="product-heading-bold">Collaborators</h6>
          </div>
          <div class="flex gap-2">
            <div
              class="approval-collaborators-list-item"
              *ngFor="let collaborator of config?.scopeVersion.collaborators | orderBy: 'id'; trackBy: trackById">
              <ng-container *ngIf="{ showAlt: false } as memberScope">
                <div
                  *ngIf="memberScope.showAlt"
                  class="user-avatar-placeholder">
                  <p>{{ collaborator.user.firstName.charAt(0) }}</p>
                </div>
                <img
                  *ngIf="!memberScope.showAlt"
                  class="user-avatar-placeholder"
                  src="{{ cdnConfig!.userProfileUrl + '/' + collaborator.user.photoUri }}"
                  alt=""
                  (error)="memberScope.showAlt = true" />
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="scopeApprovalFlowService.stateChecks.deliverableStatus.deliverablesInReview"
        class="deliverable-review-collaborators">
        <div class="approval-collaborators-list flex flex-col gap-1">
          <div class="flex items-center gap-0.5">
            <mat-icon class="material-symbols-rounded">eyeglasses</mat-icon>
            <h6 class="product-heading-bold">Reviewers</h6>
          </div>
          <div class="flex gap-2">
            <div
              class="approval-collaborators-list-item"
              *ngFor="let reviewer of deliverable.reviewers | orderBy: 'id'; trackBy: trackById">
              <ng-container *ngIf="{ showAlt: false } as memberScope">
                <i
                  *ngIf="reviewer.vote === 'ACCEPT'"
                  class="material-symbols-rounded accepted">
                  done
                </i>
                <i
                  *ngIf="reviewer.vote === 'DECLINE'"
                  class="material-symbols-rounded rejected">
                  close
                </i>
                <div
                  *ngIf="memberScope.showAlt"
                  class="user-avatar-placeholder">
                  <p>{{ reviewer.voter.firstName.charAt(0) }}</p>
                </div>
                <img
                  *ngIf="!memberScope.showAlt"
                  class="user-avatar-placeholder"
                  src="{{ cdnConfig!.userProfileUrl + '/' + reviewer.voter.photoUri }}"
                  alt=""
                  (error)="memberScope.showAlt = true" />
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="
          scopeApprovalFlowService.stateChecks.deliverableStatus.deliverablesInReview &&
          config?.scopeVersion.status === 'SUBMITTED'
        "
        class="deliverable-review-actions">
        <ng-container
          *ngIf="
            this.scopeApprovalFlowService.findDeliverableReviewer(currentUser.id, deliverable) as deliverableReviewer
          ">
          <button
            [class.deliverable-accepted]="deliverableReviewer?.vote === 'ACCEPT'"
            [disabled]="deliverableReviewer?.vote === 'ACCEPT'"
            (click)="onAcceptDeliverable.emit(deliverable)">
            {{ deliverableReviewer?.vote === 'ACCEPT' ? 'Accepted' : 'Accept' }}
          </button>
          <button
            [class.deliverable-rejected]="deliverableReviewer?.vote === 'DECLINE'"
            [disabled]="deliverableReviewer?.vote === 'DECLINE'"
            (click)="onRejectDeliverable.emit(deliverable)">
            {{ deliverableReviewer?.vote === 'DECLINE' ? 'Rejected' : 'Reject' }}
          </button>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>

<ng-container *ngIf="scopeElementsService.deliverableStates.selected[deliverable.id]">
  <scope-components
    [level]="level + 1"
    [config]="updatedConfig"
    [deliverable]="deliverable"
    [components]="componentsMap['undefined']"
    [componentMenuOptions]="componentMenuOptions"
    [feeMenuOptions]="feeMenuOptions"
    (onUpdateComponent)="onUpdateComponent.emit($event)"
    (onUpdateRole)="onUpdateRole.emit($event)"
    (onUpdateComponentTpc)="onUpdateComponentTpc.emit($event)"
    (onReorderComponentTpcs)="onReorderComponentTpcs.emit($event)"
    (onUpdateComponentFee)="onUpdateFeeItem.emit($event)"
    (onOverrideQuantity)="onOverrideComponentQuantity.emit($event)"
    (onOverrideRateCardRoleHours)="onOverrideRateCardRoleHours.emit($event)"
    (onMoveComponent)="onMoveComponent.emit($event)"
    (onMoveComponentOutsideDeliverable)="onMoveComponentOutsideDeliverable.emit($event)">
  </scope-components>

  <scope-deliverable-sections
    [sections]="deliverable.sections"
    [componentsMap]="componentsMap"
    [config]="updatedConfig"
    [deliverable]="deliverable"
    [feeMenuOptions]="feeMenuOptions"
    [componentMenuOptions]="componentMenuOptions"
    [level]="level + 1"
    (onUpdateComponent)="onUpdateComponent.emit($event)"
    (onUpdateRole)="onUpdateRole.emit($event)"
    (onUpdateComponentTpc)="onUpdateComponentTpc.emit($event)"
    (onReorderComponentTpcs)="onReorderComponentTpcs.emit($event)"
    (onUpdateDeliverableSectionTpc)="onUpdateDeliverableSectionTpc.emit($event)"
    (onReorderDeliverableSectionTpcs)="onReorderDeliverableSectionTpcs.emit($event)"
    (onUpdateFeeItem)="onUpdateFeeItem.emit($event)"
    (onOverrideComponentQuantity)="onOverrideComponentQuantity.emit($event)"
    (onOverrideRateCardRoleHours)="onOverrideRateCardRoleHours.emit($event)"
    (onMoveComponent)="onMoveComponent.emit($event)"
    (onMoveComponentOutsideDeliverable)="onMoveComponentOutsideDeliverable.emit($event)">
  </scope-deliverable-sections>

  <div
    *ngIf="config?.userColumns.SCOPE__TRAFFICKING__DELIVERABLE_ACTUALS?.selected && !config?.isTimeline"
    class="scope-row-header flex items-center align-middle"
    [has-setting]="ApplicationSetting.SCOPE__TRAFFICKING__DELIVERABLE_ACTUALS"
    [hidden]="
      !(
        scopeElementsService.deliverableStates.selected[deliverable.id] &&
        deliverable.componentsInitialised &&
        (deliverable.sections?.length || componentsMap['undefined']?.length)
      )
    ">
    <div class="column level-{{ level + 1 }} {{ config?.componentMainColumnClass }}">
      <span isEllipsisActive>{{ 'deliverable|u' | lang }} ACTUALS</span>
    </div>
    <div class="column four--columns">
      <span isEllipsisActive>Complete percentage: {{ deliverable.traffickedPercentageComplete || 0 }}%</span>
    </div>
    <div
      class="column two--columns"
      [hidden]="!config?.userColumns.SCOPEMARK_PRICE?.selected"></div>
    <div
      class="column two--columns"
      [hidden]="!config?.userColumns.AGENCY_PRICE?.selected">
      <span class="flex items-center">Actuals: {{ deliverable.getActualHours() }} hrs</span>
    </div>
    <div class="column two--columns"></div>
  </div>

  <scope-third-party-costs
    *ngIf="
      deliverable.thirdPartyCosts?.length &&
      scopeElementsService.deliverableStates.selected[deliverable.id] &&
      !config?.isTimeline
    "
    [parent]="deliverable"
    [config]="updatedConfig"
    [level]="level + 1"
    [columns]="getTpcColumns()"
    (onUpdateTpc)="updateDeliverableTpc($event)"
    (onReorderTpcs)="reorderDeliverableTpcs($event)">
  </scope-third-party-costs>

  <scope-fees
    *ngIf="
      deliverable.feeItems?.length &&
      scopeElementsService.deliverableStates.selected[deliverable.id] &&
      !config?.isTimeline
    "
    [has-setting]="ApplicationSetting.DELIVERABLE__ENABLE_FEES"
    [parent]="deliverable"
    [columns]="scopeElementsService.deliverableFeeColumns"
    [level]="level + 1"
    [config]="updatedConfig"
    [feeMenuOptions]="feeMenuOptions"
    [tableStates]="scopeElementsService.deliverableFeeStates"
    (onUpdateFeeItem)="onUpdateFeeItem.emit({ feeItem: $event, deliverable })">
  </scope-fees>
</ng-container>
